/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Link } from '@coursera/cds-core';

const styles = {
  link: css`
    && {
      color: var(--cds-color-interactive-secondary);
    }
  `,
  currentLink: css`
    && {
      font-weight: bold;
      color: var(--cds-color-interactive-primary);
    }
  `,
};

type Props = {
  label: string;
  href?: string;
  isCurrent?: boolean;
  onClick?: () => void;
  openInNewWindow?: boolean;
};

const AdminLinkGridItem = ({ isCurrent, label, href, onClick, openInNewWindow }: Props) => {
  if (!href) return null;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (onClick) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <Grid item>
      <Link
        id={`${label}-link`}
        href={href}
        typographyVariant="bodySecondary"
        variant="quiet"
        css={[styles.link, isCurrent && styles.currentLink]}
        onClick={handleClick}
        {...(openInNewWindow ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {label}
      </Link>
    </Grid>
  );
};

export default AdminLinkGridItem;
